import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetWaveByIdResponse,
    GetWaveInvoicesParams,
    GetWaveInvoicesResponse,
    GetWavesParams,
    GetWavesResponse,
    WavePayload
} from './types/waves'

type ApiGetWavesResponse = Promise<AxiosResponse<GetWavesResponse>>
type ApiGetWaveByIdResponse = Promise<AxiosResponse<GetWaveByIdResponse>>
type ApiGetWaveInvoicesResponse = Promise<AxiosResponse<GetWaveInvoicesResponse>>
type ApiCreateWaveResponse = Promise<AxiosResponse<void>>
type ApiUpdateWaveResponse = Promise<AxiosResponse<void>>
type ApiDeleteWaveResponse = Promise<AxiosResponse<void>>

export function getWaves(params: GetWavesParams): ApiGetWavesResponse {
    return http.get('/dispatcher/api/waves', { params })
}

export function getWaveById(wave_id: number): ApiGetWaveByIdResponse {
    return http.get(`/dispatcher/api/waves/${wave_id}`)
}

export function getWaveInvoices(wave_id: number, params: GetWaveInvoicesParams): ApiGetWaveInvoicesResponse {
    return http.get(`/dispatcher/api/waves/${wave_id}/invoices`, { params })
}

export function createWave(payload: WavePayload): ApiCreateWaveResponse {
    return http.post('/dispatcher/api/waves', payload)
}

export function updateWave(wave_id: number, payload: WavePayload): ApiUpdateWaveResponse {
    return http.put(`/dispatcher/api/waves/${wave_id}`, payload)
}

export function deleteWave(wave_id: number): ApiDeleteWaveResponse {
    return http.delete(`/dispatcher/api/waves/${wave_id}`)
}

export default {
    getWaves,
    getWaveById,
    getWaveInvoices,
    createWave,
    updateWave,
    deleteWave
}